import * as angular from 'angular';

import ApiModule from '../api/api.module';
import BenchmarksModule from '../benchmarks/benchmarks.module';
import ChartsModule from '../charts/charts.module';
import CoreModule from '../core/core.module';
import NavigationModule from '../navigation/navigation.module';

import * as api from './../api/api.service';
import * as featuresApi from './../api/features.service';

import { AptitudeBarGaugeComponent } from './aptitudeBarGauge.component';
import BuyerImpactService from './buyerImpact.service';
import FilterZeroSpendAndZeroSavings from './filterZeroSpendAndZeroSavings.filter';
import NaDirective from './na.directive';

import CloseDetailsDirective from './closeDetails.directive';
import MainController from './main.controller';
import SellerImpactFactory from './sellerImpact.service';
import SetAllSystemsInModalCtrl from './setAllSystemsInModal.controller';

export default angular
  .module('ImpactApp', [
    ApiModule, // Is this actually needed here?
    BenchmarksModule,
    ChartsModule,
    CoreModule,
    NavigationModule,
    'aptitude',
    'mgcrea.ngStrap',
    'scrollable-table'
  ])
  .component('aptitudeBarGauge', AptitudeBarGaugeComponent)
  .factory('buyerImpactService', BuyerImpactService)
  .filter('filterZeroSpendAndZeroSavings', FilterZeroSpendAndZeroSavings)
  .directive('nA', NaDirective)
  .directive('closeDetails', CloseDetailsDirective)
  .controller('MainCtrl', MainController)
  .factory('sellerImpactService', SellerImpactFactory)
  .controller('SetAllSystemsInModal', SetAllSystemsInModalCtrl).name;
